// extracted by mini-css-extract-plugin
export default {"page-is-not-available-message":"WKKQP97___page-is-not-available-message","pageIsNotAvailableMessage":"WKKQP97___page-is-not-available-message"};